import styled from 'styled-components/macro';
import Checkbox from '@mui/material/Checkbox';

const StyledCheckbox = styled(Checkbox)``;
export {StyledCheckbox};
